import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { influencerForgotPassword } from '../lib/influencer-api';
import { FaArrowLeft, FaCheckCircle } from '../lib/icons';

export default function InfluencerForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim() || submitting) return;
    setSubmitting(true);
    try {
      await influencerForgotPassword(email.trim().toLowerCase());
    } catch {
      // ignore — backend already returns success to prevent enumeration
    } finally {
      setDone(true);
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4 py-12">
      <Helmet>
        <title>Forgot Password — EatMeat Influencer Portal</title>
      </Helmet>
      <div className="w-full max-w-md bg-white rounded-2xl border border-gray-100 shadow-sm p-8">
        <Link to="/influencer" className="inline-flex items-center gap-2 text-xs text-gray-500 hover:text-gray-700 mb-6">
          <FaArrowLeft /> Back to login
        </Link>
        <h1 className="text-xl font-extrabold text-gray-900 tracking-tight">Forgot your password?</h1>
        <p className="text-sm text-gray-500 mt-1">
          Enter the email on your influencer account and we'll send you a link to reset your password.
        </p>

        {done ? (
          <div className="mt-6 px-4 py-4 rounded-xl bg-green-50 border border-green-200 text-sm text-green-800 flex items-start gap-2">
            <FaCheckCircle className="mt-0.5 text-green-600 shrink-0" />
            <div>
              If <span className="font-semibold">{email}</span> is registered, a reset link is on its way.
              The link is valid for 1 hour. Check your spam folder if you don't see it.
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="mt-6 space-y-4">
            <div>
              <label className="block text-xs font-semibold text-gray-600 uppercase tracking-wider mb-1.5">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                className="w-full px-4 py-3 rounded-xl bg-gray-50 border border-gray-200 text-sm focus:bg-white focus:border-primary focus:ring-4 focus:ring-primary/10 focus:outline-none transition-all"
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full inline-flex items-center justify-center gap-2 py-3 bg-primary text-white rounded-xl font-semibold hover:bg-primary/90 disabled:opacity-60 transition-colors"
            >
              {submitting ? 'Sending…' : 'Send reset link'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
